import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const LINKS_SCHEMA = Object.freeze({
  ELECTRONIC_PAYMENT_URL: '',
  NOTIFY_PAYMENT_URL: '',
  BEACON_URL: '',
  PORTAL_URL: '',
});
export const RECORD = generateSchema(LINKS_SCHEMA);
export const KEYS: any = generateKeys(LINKS_SCHEMA);

export class Links extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get beaconUrl(): string {
    return this.get(KEYS.BEACON_URL);
  }

  get electronicPaymentUrl(): string {
    return this.get(KEYS.ELECTRONIC_PAYMENT_URL);
  }

  get notifyPaymentUrl(): string {
    return this.get(KEYS.NOTIFY_PAYMENT_URL);
  }

  get portalUrl(): string {
    return this.get(KEYS.PORTAL_URL);
  }
}
